import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormTabItem } from '../../../core/models/form.models';

export interface TabChangeEvent {
  tabIndex: number;
  activeTabName: string;
}

@Component({
  selector: 'app-form-tabs',
  templateUrl: './form-tabs.component.html',
  styleUrls: ['./form-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormTabsComponent implements OnInit {
  @Input() formTab: any;
  @Input() counters: number[] = [];

  @Output() onTabChanged = new EventEmitter<TabChangeEvent>();

  ngOnInit(): void {
    if (this.formTab?.tab === 'filters') {
      this.formTab.items[1].active = true;
    } else if (this.formTab?.tab === 'dimensions') {
      this.formTab.items[2].active = true;
    } else {
      this.formTab.items[0].active = true;
    }
    this.onTabChanged.emit({
      tabIndex: this.formTab.tabIndex,
      activeTabName: this.formTab.items[0].name,
    });
  }

  activateTab(tab: FormTabItem, index: number) {
    this.formTab.items.forEach((t) => (t.active = false));
    tab.active = true;
    this.onTabChanged.emit({
      tabIndex: this.formTab.tabIndex,
      activeTabName: tab.name,
    });
  }

  get hasCounters(): boolean {
    return this.formTab?.items?.some((item) => !!item.counter) ?? false;
  }
}
